import { LegacyRef, useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { ComplaintContainer, Label } from "../../screens/complaint/Complaint.styled";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import General from "../../stores/GeneralStore";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { observer } from "mobx-react";
import "./temp.css";
import {
  ThankyouHeader,
  ThankyouMessage,
} from "../../components/SocialCaseTbas/Social.styled";
import thanks from "../../assets/thanks.svg";
import complaintAndLinkStore from "../../stores/ComplaintAndLinkStore";
import HappyMeterStore from "../../stores/HappyMeter";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { useNavigate } from "react-router-dom";
import { NotifySuccess } from "../../utils/ShowSuccess";
interface Props extends BaseProps {
  onCross: any;
  accountNo?: any
  getUser?: any
}
const DeLinkAccountModal = ({ onCross, accountNo, getUser }: Props) => {
  const [thankyou, setThankyou] = useState(false);
  const [delLoader, setdelLoader] = useState(false);
  const [parcelNumber, setParcelNumber] = useState<string>('');
  const [accounts, setAccounts] = useState<{ sewerageId: string }[]>([]);

  const handleContinue = async () => {
    try {
      setdelLoader(true);
      const res = await complaintAndLinkStore.delinkAccount({
        errorId: "delinkAccountError",
        data: accountNo,
      });
      if (res?.message == "Success") {
        onCross()
        setdelLoader(false);
        getUser()
        NotifySuccess(General?.codeLabels[res?.result?.message]?.label);
      }
    } catch (error) {
      setdelLoader(false);
    }
  };

  const navigate = useNavigate()
  return (
    <div
      style={{
        zIndex: 9999,
        backgroundColor: General.contrast.contrastColor
        ? General.contrast.contrastColor
        : '#fff',
        overflow: "auto",
        width: General?.isLargeScreen ? "50%" : "100%",
        margin: "auto",
        direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr",
      }}
    >
      <div
        style={{

          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : General?.ColorAss,
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 id="modal-title" style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff', margin: 0
        }}>
          {General?.codeLabels['cm_delink']?.label ? General?.codeLabels['cm_delink']?.label : "Delink Property"}
        </h1>
        <span
          style={{
            color: General.contrast.contrastColor
              ? General.contrast.contrastColor
              : '#fff', fontSize: 32, cursor: "pointer"
          }}
          onClick={onCross}
        >
          x
        </span>
      </div>

      <TabContainer style={{ padding: '20px',
      background: General.contrast.contrastColor
      ? General.contrast.contrastColor
      : "#fff",
      
      }}>
        {" "}
        <Label style={{
          fontWeight: "800", fontSize: '15px', 
          color: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : General.ColorAss,
            
        }}>
          {General?.codeLabels['cm_delink_confirmation']?.label ? General?.codeLabels['cm_delink_confirmation']?.label : "Are You Sure yuo want to delink?"}
        </Label>

        <hr style={{ gridColumn: "1 / span 2", width: "100%" }} />

        
          <TabContainer
        style={{
          padding: "0.3rem",
          display: "flex",
          gap: "0.5rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "#fff",
          color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
        }}
      >

        <ButtonsContainer
          style={{ display: "flex", gap: "12px", width: "fit-content", paddingBottom: "1rem" }}
        >
          <ButtonSecondary
            style={{ 
              width: "45%", 
              padding: "auto",
              fontSize:`${General.accessibility.fontSize}rem`,
              color: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
              background: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground : "white",
              borderColor: General?.contrast?.contrastColor ? General?.contrast?.contrastColor : General?.ColorAss,
            }}
            onClick={onCross}
          >
            {General?.codeLabels["cm_usepassloginpagecancel"]?.label !== undefined ? General?.codeLabels["cm_usepassloginpagecancel"]?.label : "CANCEL"}

          </ButtonSecondary>
          <ButtonSecondary
            style={{
              width: "45%",
              padding: "auto",
              color: General?.contrast?.contrastBackground ? General?.contrast?.contrastBackground:"#fff",
              background: General?.contrast?.contrastColor ? General?.contrast?.contrastColor :General?.ColorAss,
              border:"none",
              whiteSpace: "nowrap",fontSize:`${General.accessibility.fontSize}rem`
            }}
            onClick={handleContinue}
          >
            {General?.codeLabels["cm_btncontinue"]?.label !== undefined ? General?.codeLabels["cm_btncontinue"]?.label : "Continue"}
         </ButtonSecondary>
        </ButtonsContainer>
      </TabContainer>
      </TabContainer>


    </div>
  );
}
export default observer(DeLinkAccountModal);